module.exports = __webpack_public_path__ + "static/img/product23.ea67896.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product23.png
// module id = xLg5
// module chunks = 13